import React, { useState } from "react";

type Props = {
  icon: string;
  label?: string;
  active?: boolean;
  showDrawerMenu: boolean;
  onClick?: () => void;
};

export const DrawerMenuButton: React.FC<Props> = ({
  icon,
  label,
  active = false,
  showDrawerMenu,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      className={`${
        active
          ? "bg-[#2557a1] bg-opacity-40"
          : "hover:bg-[#2557a1] hover:bg-opacity-20"
      } flex items-center justify-start space-x-4 py-2 px-4 rounded-2xl transition delay-75 ease-in-out text-white`}
    >
      <img className="w-5 h-8 3xl:w-6 3xl:h-9" src={icon} alt="icon" />
      {label && showDrawerMenu ? (
        <span>{label}</span>
      ) : label && isHovered ? (
        <div className="absolute left-8 bg-slate-900 w-32 flex justify-center items-center rounded-xl">
          <span className="text-sm w-32 py-1">{label}</span>
        </div>
      ) : (
        ""
      )}
    </button>
  );
};
